import { setData } from "astrid-firestore/src/helpers";

export default function submitAutoApprovalRule({ organization, language, type, unit, currency, threshold }) {
	const id = `${language}_${type}_${unit}_${currency}`;

	return setData(organization.ref.collection("settings").doc("autoApprovePrices"), {
		[id]: { id, language, type, unit, currency, threshold },
	});
}
